const chatButton = value => {
  let number = value
  if (value.startsWith('0')) number = value.substring(1)
  if (value.startsWith('62')) number = value.substring(2)
  window.open(`https://wa.me/62${number}`)
}

export default chatButton
